export default () => {
    const nodeSelectors = {
        container: '[js-table-of-contents="container"]',
        item: '[js-table-of-contents="item"]',
    }

    function init() {
        if (!document.querySelector(nodeSelectors.container)) {
            return
        }

        jQuery(nodeSelectors.container).each(function () {
            let container = jQuery(this)
            let contentTarget = container.data('js-table-of-contents--target')
            let items = container.find(nodeSelectors.item)

            // Set editor headers IDs
            jQuery(contentTarget + ' :header').each(function () {
                let $element = jQuery(this)
                let id = $element.text().replace(/[^a-zA-Z0-9 ]/g, '').replace(/\s+/g, '-').toLowerCase()
                $element.attr('id', id)
            })
        })
    }

    return Object.freeze({
        init,
    })
}